module.exports = __webpack_public_path__ + "static/NanumSquareL-f2a56a3bef1a85a94f09f8d4ffe5eb46.ttf";